import { ModalControls } from "../../../../customHooks/useModalControl";
import {
  getOffsetFromPage,
  getPageFromOffset,
} from "../../../../helperFunctions";
import {
  MembershipApprovalQuery,
  MembershipApprovalsResponse,
} from "../../../../redux/features/approvals/approvals.type";
import { SingleCooperativeMember } from "../../../../redux/features/cooperative/cooperative.type";
import { ApprovalActionDetails } from "../../../../utils/types";
import { TimeText } from "../../../typography/timeText";
import { TableComponent } from "../../table";

export const SingleMembershipApproval = ({
  modalControls,
  setSelectedIds,
  selectedIds,
  approvals,
  setActionDetails,
  setSelectedEntry,
  fetching,
  query,
  setQuery,
}: {
  modalControls: ModalControls;
  selectedIds: number[];
  setSelectedIds: (v: number[]) => void;
  approvals?: MembershipApprovalsResponse;
  setActionDetails: (v: ApprovalActionDetails) => void;
  setSelectedEntry: (v: SingleCooperativeMember) => void;
  fetching: boolean;
  query: MembershipApprovalQuery;
  setQuery: (v: MembershipApprovalQuery) => void;
}) => {
  const { handleModalOpen } = modalControls;

  return (
    <TableComponent
      mobileCardView
      headers={["Name", "Email", "Registration Date"]}
      headerActionProps={{
        hasActions: true,
        hasCheckbox: true,
        checked:
          selectedIds.length > 0 &&
          selectedIds.length === approvals?.data?.results?.length,
        onCheck: () => {
          setSelectedIds(approvals?.data?.results?.map((i) => i.id) ?? []);
        },
        onUncheck: () => {
          setSelectedIds([]);
        },
        hasMoreMenu: true,
      }}
      rows={
        approvals?.data?.results?.map((entry, idx) => {
          return {
            id: entry.id,
            onClick: () => {
              if (selectedIds.includes(entry.id)) {
                setSelectedIds(selectedIds.filter((i) => i !== entry.id));
              } else {
                setSelectedIds([...selectedIds, entry.id]);
              }
            },
            items: [
              <p className="min-w-fit whitespace-nowrap">
                {entry?.User?.FirstName} {entry?.User?.LastName}
              </p>,
              <p>{entry?.User?.Email}</p>,
              <TimeText
                timeString={entry.DateAdded}
                key={`entry-${entry.id}-date-${idx}`}
              />,
            ],
            actionProps: {
              hasActions: true,
              hasCheckbox: true,
              checked: selectedIds.includes(entry.id),
              onCheck: () => {},
              onUncheck: () => {},
              hasMoreMenu: true,
              moreOptions: [
                {
                  icon: "profile",
                  text: "View Details",
                  onClick: () => {
                    setSelectedEntry(entry);
                    handleModalOpen("memberDetailsModal");
                  },
                  hidden: false,
                },
                {
                  icon: "verified-icon",
                  text: "Accept",
                  onClick: () => {
                    setActionDetails({
                      type: "single",
                      isApprove: true,
                      singleId: entry.id,
                    });
                    setSelectedEntry(entry);

                    handleModalOpen("confirmationModal");
                  },
                },
                {
                  icon: "close-icon",
                  text: "Decline",
                  onClick: () => {
                    setActionDetails({
                      type: "single",
                      isApprove: false,
                      singleId: entry.id,
                    });
                    setSelectedEntry(entry);

                    handleModalOpen("confirmationModal");
                  },
                },
              ],
            },
          };
        }) ?? []
      }
      stickyLastCol
      isRowClickable={true}
      onRowClick={() => {}}
      isTableEmpty={[0, undefined].includes(approvals?.data?.results?.length)}
      emptyTitle="No Pending Approvals"
      isLoading={fetching}
      isPaginated
      currentPage={getPageFromOffset(query.offset!, query.limit!)}
      totalCount={approvals?.data?.count}
      itemsPerPage={query.limit}
      onPageChange={(page) => {
        setQuery({
          ...query,
          offset: getOffsetFromPage(page, query.limit!),
        });
        setSelectedIds([]);
      }}
    />
  );
};
